import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, BookOpen, ShoppingCart, Snowflake, Zap } from 'lucide-react';
export const ProductShowcase = () => {
  return <section className="bg-white px-4 py-10 md:py-20 lg:px-8" id="product" data-id="element-180">
      <div className="mx-auto max-w-6xl" data-id="element-181">
        {/* Testimonial Image - moved here */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mb-12 mx-auto w-full max-w-md" data-id="element-182">
          <img src="https://cdn.magicpatterns.com/uploads/pRzUXFGu3fTcBnFewWkenA/testimonio.jpg" alt="Testimonio de María_C_OcupadaMamá" className="w-full rounded-lg shadow-md" data-id="element-183" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mb-12 text-center" data-id="element-184">
          <h2 className="mb-4 font-serif text-3xl font-bold text-text-dark md:text-5xl" data-id="element-185">
            Esto es lo que vas a recibir hoy por menos de lo que cuesta una
            pizza:
          </h2>
        </motion.div>

        <div className="grid gap-12 lg:grid-cols-2 lg:items-center" data-id="element-186">
          {/* Left: Image */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="order-2 lg:order-1" data-id="element-187">
            <img src="https://cdn.magicpatterns.com/uploads/boZK8YNxgQmJ56ZSeWZ8rb/2.png" alt="Las 4 Guías de Temporada" className="w-full rounded-2xl shadow-xl" data-id="element-188" />
          </motion.div>

          {/* Right: Content */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="order-1 flex flex-col space-y-8 lg:order-2" data-id="element-189">
            <div data-id="element-190">
              <ul className="space-y-4" data-id="element-191">
                <li className="flex items-start space-x-3" data-id="element-192">
                  <Snowflake className="mt-1 h-5 w-5 flex-shrink-0 text-sage" data-id="element-193" />
                  <span className="text-text-dark" data-id="element-194">
                    <strong data-id="element-195">El Protocolo Maestro de las 4 Estaciones:</strong>{' '}
                    Guías paso a paso para Invierno, Primavera, Verano y Otoño.
                  </span>
                </li>
                <li className="flex items-start space-x-3" data-id="element-196">
                  <ShoppingCart className="mt-1 h-5 w-5 flex-shrink-0 text-sage" data-id="element-197" />
                  <span className="text-text-dark" data-id="element-198">
                    <strong data-id="element-199">Listas de Compras Inteligentes:</strong> Para que
                    entres y salgas del supermercado en tiempo récord sin gastar
                    de más.
                  </span>
                </li>
                <li className="flex items-start space-x-3" data-id="element-200">
                  <Zap className="mt-1 h-5 w-5 flex-shrink-0 text-sage" data-id="element-201" />
                  <span className="text-text-dark" data-id="element-202">
                    <strong data-id="element-203">Instrucciones de "Activación Rápida":</strong> No
                    importa si usas olla de presión, horno o sartén; te digo
                    exactamente cómo servir cenas perfectas en minutos.
                  </span>
                </li>
              </ul>
            </div>
          </motion.div>
        </div>

        {/* Bonuses Section */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mt-20 rounded-3xl bg-white p-8 shadow-xl md:p-12 border border-gray-100" data-id="element-204">
          <div className="grid gap-10 md:grid-cols-2 md:items-center" data-id="element-205">
            <div data-id="element-206">
              <h3 className="mb-2 font-serif text-2xl font-bold text-terracotta" data-id="element-207">
                Además, si te unes hoy, te entrego estos 3 Bonos Exclusivos:
              </h3>
              <ul className="mt-6 space-y-4 text-lg" data-id="element-208">
                <li className="flex items-center space-x-3" data-id="element-209">
                  <span className="flex h-8 w-8 items-center justify-center rounded-full bg-gray-100 text-sm font-bold text-terracotta" data-id="element-210">
                    1
                  </span>
                  <span className="font-medium text-text-dark" data-id="element-211">
                    Guía de Ahorro en el Presupuesto de Comida.
                  </span>
                </li>
                <li className="flex items-center space-x-3" data-id="element-212">
                  <span className="flex h-8 w-8 items-center justify-center rounded-full bg-gray-100 text-sm font-bold text-terracotta" data-id="element-213">
                    2
                  </span>
                  <span className="font-medium text-text-dark" data-id="element-214">
                    Desafío de Limpieza y Orden del Congelador.
                  </span>
                </li>
                <li className="flex items-center space-x-3" data-id="element-215">
                  <span className="flex h-8 w-8 items-center justify-center rounded-full bg-gray-100 text-sm font-bold text-terracotta" data-id="element-216">
                    3
                  </span>
                  <span className="font-medium text-text-dark" data-id="element-217">
                    Hoja Maestra de Guarniciones de Preparación Rápida.
                  </span>
                </li>
              </ul>

              <div className="mt-8 space-y-4" data-id="element-218">
                <p className="text-xl text-gray-400 line-through decoration-red-400 decoration-2" data-id="element-219">
                  Valor Total: $148
                </p>
                <a href="#mid-pricing" onClick={e => {
                e.preventDefault();
                document.getElementById('mid-pricing')?.scrollIntoView({
                  behavior: 'smooth',
                  block: 'center'
                });
              }} className="group inline-flex w-full items-center justify-center rounded-full bg-terracotta px-8 py-4 text-lg font-bold text-white shadow-lg transition-all hover:bg-[#d6761b] hover:shadow-xl hover:-translate-y-0.5 md:w-auto" data-id="element-220">
                  Obtén el Paquete de las 4 Estaciones hoy por solo $9.98
                  <ArrowRight className="ml-2 h-5 w-5 transition-transform group-hover:translate-x-1" data-id="element-221" />
                </a>
              </div>
            </div>

            <div className="relative overflow-hidden rounded-xl shadow-lg" data-id="element-222"></div>
          </div>

          {/* Individual Bonus Images */}
          <div className="mt-8 grid grid-cols-1 gap-6 sm:grid-cols-3" data-id="element-223">
            <img src="https://cdn.magicpatterns.com/uploads/pCRByrYVXuGSjhn77NNxJy/Bono_1.png" alt="Guía de Ahorro en el Presupuesto de Comida" className="w-full rounded-xl shadow-md" data-id="element-224" />
            <img src="https://cdn.magicpatterns.com/uploads/v9VzhrANaPzeqMPY7strqg/Bono_2.png" alt="Hoja Maestra de Guarniciones Rápidas" className="w-full rounded-xl shadow-md" data-id="element-225" />
            <img src="https://cdn.magicpatterns.com/uploads/nmia2XLaB8byCj1Jyn8vyQ/Bono_3.png" alt="Desafío de Limpieza y Orden del Congelador" className="w-full rounded-xl shadow-md" data-id="element-226" />
          </div>
        </motion.div>
      </div>
    </section>;
};